import { Check, X } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export const FeatureMatrix = () => {
  const features = [
    {
      name: "Price",
      teal: "$36/mo",
      resumeWorded: "$49/mo",
      jobCopilot: "$24/mo",
      lazyApply: "$99 one-time",
      loopbaan: "$29/mo",
      loopbaanHighlight: true,
    },
    {
      name: "AI Resume Builder",
      teal: "Limited",
      resumeWorded: true,
      jobCopilot: false,
      lazyApply: false,
      loopbaan: "Unlimited",
      loopbaanHighlight: true,
    },
    {
      name: "Cover Letter AI",
      teal: "Limited",
      resumeWorded: false,
      jobCopilot: true,
      lazyApply: false,
      loopbaan: "Unlimited",
      loopbaanHighlight: true,
    },
    {
      name: "ATS Score Check",
      teal: true,
      resumeWorded: true,
      jobCopilot: false,
      lazyApply: false,
      loopbaan: "Unlimited",
      loopbaanHighlight: true,
    },
    {
      name: "LinkedIn Optimizer",
      teal: false,
      resumeWorded: true,
      jobCopilot: false,
      lazyApply: false,
      loopbaan: true,
    },
    {
      name: "Smart Auto-Apply",
      teal: false,
      resumeWorded: false,
      jobCopilot: "30/mo",
      lazyApply: "Unlimited",
      loopbaan: "20/mo",
    },
    {
      name: "Job Search",
      teal: "Basic",
      resumeWorded: false,
      jobCopilot: true,
      lazyApply: true,
      loopbaan: "Free tier + Pro/Premium",
      loopbaanHighlight: true,
    },
    {
      name: "Salary Negotiation",
      teal: false,
      resumeWorded: false,
      jobCopilot: false,
      lazyApply: false,
      loopbaan: true,
      exclusive: true,
    },
    {
      name: "Interview Prep",
      teal: false,
      resumeWorded: false,
      jobCopilot: false,
      lazyApply: false,
      loopbaan: "AI-Powered",
      exclusive: true,
      loopbaanHighlight: true,
    },
    {
      name: "Company Insights",
      teal: false,
      resumeWorded: false,
      jobCopilot: false,
      lazyApply: false,
      loopbaan: true,
      exclusive: true,
    },
    {
      name: "Application Tracker",
      teal: true,
      resumeWorded: false,
      jobCopilot: true,
      lazyApply: true,
      loopbaan: true,
    },
  ];

  const renderCell = (value: boolean | string) => {
    if (value === true) {
      return <Check className="w-5 h-5 text-primary mx-auto" />;
    }
    if (value === false) {
      return <X className="w-5 h-5 text-muted-foreground/30 mx-auto" />;
    }
    return <span className="text-sm">{value}</span>;
  };

  return (
    <div className="mb-16">
      <h3 className="text-3xl font-bold text-center mb-8">
        Feature Comparison Matrix
      </h3>
      
      <div className="overflow-x-auto">
        <div className="inline-block min-w-full align-middle">
          <table className="w-full border-collapse bg-card rounded-lg overflow-hidden">
            <thead>
              <tr className="bg-muted/50">
                <th className="p-4 text-left font-semibold border-b">Feature</th>
                <th className="p-4 text-center font-semibold border-b border-l">Teal</th>
                <th className="p-4 text-center font-semibold border-b border-l">Resume Worded</th>
                <th className="p-4 text-center font-semibold border-b border-l">JobCopilot</th>
                <th className="p-4 text-center font-semibold border-b border-l">LazyApply</th>
                <th className="p-4 text-center font-semibold border-b border-l bg-primary/5">
                  <div className="flex items-center justify-center gap-2">
                    Loopbaan.ai
                    <Badge variant="default" className="ml-1">Best Value</Badge>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {features.map((feature, idx) => (
                <tr 
                  key={idx}
                  className="border-b last:border-b-0 hover:bg-muted/20 transition-colors"
                >
                  <td className="p-4 font-medium">
                    {feature.name}
                    {feature.exclusive && (
                      <Badge variant="secondary" className="ml-2 text-xs">
                        Exclusive
                      </Badge>
                    )}
                  </td>
                  <td className="p-4 text-center border-l">{renderCell(feature.teal)}</td>
                  <td className="p-4 text-center border-l">{renderCell(feature.resumeWorded)}</td>
                  <td className="p-4 text-center border-l">{renderCell(feature.jobCopilot)}</td>
                  <td className="p-4 text-center border-l">{renderCell(feature.lazyApply)}</td>
                  <td className={`p-4 text-center border-l font-semibold ${feature.loopbaanHighlight ? 'bg-primary/5' : ''}`}>
                    {renderCell(feature.loopbaan)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="text-center mt-6">
        <p className="text-muted-foreground">
          ✨ With Loopbaan.ai Premium ($79/mo), you get EVERYTHING above + 200 credits/month + unlimited 1-2 credit actions
        </p>
      </div>
    </div>
  );
};
